// == datepicker ==
// id指定するとき
//$(function() {
//  $("#datepicker").datepicker({
//  });
//});

$(document).ready(function(){
  $('input.datepicker').datepicker({
    dateFormat: 'yy-mm-dd',
  });
});

// == item autocomplete ==
// item_idのsearchは文字追加時の食い違いが出るので止める
$(function() {
  // 入力補完を実施する要素に単語リストを設定
  $("#inputItemName").autocomplete({
    source: '/front/item_search.json',
    autoFocus: true,
    minLength: 1,
    delay: 300,
  });
});

// 日本語入力 Type A >>
// 日本語入力をスタートしたら無効化
$('#inputItemName').on('compositionstart', function(){$('#inputItemName').autocomplete('disable');});
// 日本語入力が確定したら有効化
$('#inputItemName').on('compositionend', function(){$('#inputItemName').autocomplete('enable');});
// << Type A

// 日本語入力 easy autocomplete用 Type B >>
// 以下を追加
//$inputItemName.on('compositionend', function () {
//  let evt = jQuery.Event("keyup");
//  evt.keyCode = 41;
//  $inputItemName.trigger(evt);
//});
// << Type B


// == site autocomplete ==
// 現場を選択するautocomplete -- all site用
// 2025/4/2に追加
// 超重要！
// 1) site_idはオリジナルのselectにあるので、共存するときは使えない
//    なので、こちらはsite_valueとする
// 2) siteはactiveとallで分ける必要がある
$(document).ready(function() {
  // ここでactiveかallを取得
  //const searchType = $typeElement.text(); // div id=の時
  const searchType = $("#site-search-type").val(); // input id=の時
  const apiUrl = "/front/search_site.json?type=" + encodeURIComponent(searchType);

  //console.log("API URL:", apiUrl);

  $("#site_label").autocomplete({
    source: function(request, response) {
      $.ajax({
        url: apiUrl,  // ここがポイント
        dataType: "json",
        data: { term: request.term },
        success: function(data) {
          response(data);
        }
      });
    },
    minLength: 1,
    delay: 300,
    select: function(event, ui) {

      // ui.itemはui.siteではない jsonのデータが格納されている
      //console.log('Selected Item:', ui.item);  // 選択されたアイテムをログに出力

      $("#site_label").val(ui.item.label);  // テキストフィールドに選択されたラベルをセット
      $("#site_value").val(ui.item.value);  // 隠しフィールドに選択されたサイトのIDをセット

      //console.log('site_label:', $("#site_label").val());  // site_labelの値をログに出力して確認
      //console.log('site_value:', $("#site_value").val());  // site_valueの値をログに出力して確認

      $("#error-message").hide();  // エラーメッセージを非表示
      return false; // デフォルト動作を防ぐ
    },
    change: function(event, ui) {
      if (!ui.item) {
        $("#site_label").val("");
        $("#site_value").val("");       // 隠しフィールドをリセット
        $("#error-message").show();  // エラーメッセージを表示
      } else {
        $("#error-message").hide();  // 正常に選択された場合はエラーメッセージを非表示
      }
    }
  });
});
